module.exports = __webpack_public_path__ + "media/images/communities/logos/wjcna-7df12bc408cac172d2c3a0d4a201bd2d.png";